import { AvailableHome } from '@sales-app/types/Home'

export namespace PropertyHomes {
  export namespace GET {
    export type Response = PropertyHomes_API_Response
    export type Error = unknown
  }

  export function getPropertyHomes(propertySlug: string | null) {
    return { url: `/api/v1/properties/${propertySlug}/homes.json` }
  }
}

export interface PropertyHomes_API_Response {
  data: PropertyHomesAPI_Data
}
export interface PropertyHomesAPI_Data {
  homes: AvailableHome[]
}
